import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[620px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20abstract%20Japanese%20aesthetic%20background%20with%20soft%20cherry%20blossom%20petals%20drifting%20on%20a%20warm%20cream%20gradient%2C%20minimalist%20Japanese%20design%20elements%2C%20subtle%20golden%20accents%2C%20clean%20artistic%20composition%2C%20luxurious%20magazine%20editorial%20backdrop&width=1600&height=900&seq=hero-bg-jp-actress&orientation=landscape"
        alt="日本女优大全背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <div className="max-w-3xl w-full">
          <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-sparkling-line text-accent-300 text-xs"></i>
            </div>
            <span className="text-xs text-background-50/90 font-medium">最全面的日本女优参考资料</span>
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
            日本女优大全
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
            完整收录数千位日本演艺女优的详细资料、出道背景、代表作品与最新动态，助您快速找到心仪的女优信息
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-8">
            <Link
              to="/category/drama-actress"
              className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              浏览女优列表
              <span className="ml-2">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
            <Link
              to="/category/popular-ranking"
              className="px-6 py-3 bg-background-50/15 backdrop-blur-sm hover:bg-background-50/25 text-background-50 font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm border border-background-50/30"
            >
              人气排行榜
              <span className="ml-2">
                <i className="ri-fire-line"></i>
              </span>
            </Link>
          </div>
          <div className="flex items-center justify-center gap-6 text-white/60 text-xs">
            <div className="flex items-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-user-star-line"></i>
              </div>
              <span>12+ 位精选女优</span>
            </div>
            <div className="flex items-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-folders-line"></i>
              </div>
              <span>6 大分类</span>
            </div>
            <div className="flex items-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-refresh-line"></i>
              </div>
              <span>每日更新</span>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-s-line text-white/50 text-xl animate-bounce"></i>
        </div>
      </div>
    </section>
  );
}